import styled from 'styled-components';
import { container, screen } from 'theme';

export const Root = styled.div``;

export const Container = styled.div`
  max-width: ${container('xlMax')};
  margin: auto;

  @media (max-width: ${screen('xl')}) {
    padding: 0 1.5rem;
  }
`;
